import {FC, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Toaster} from "react-hot-toast";

import clsx from "clsx";

import {AppDispatch} from "../../../redux/reducer/store";

import Loader from "../../custom/loader/loader";
import LimitSelect from "../../custom/limitSelect/limitSelect";
import Pagination from "../../pagination/pagination";

import "../table.scss";

import {IUserOptions} from "../../../types/interfaces";
import {IContract} from "../../../types/contractsInterface";
import {actionGetServiceTypesSelect,} from "../../../redux/action/easymerch/actionServiceTypes";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableCustomerContractsList: FC = () => {

    const dispatch = useDispatch<AppDispatch>();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [startPage, setStartPage] = useState<number>(1);
    const [isPending, setIsPending] = useState<boolean>(true);

    const [visibleRows, setVisibleRows] = useState([]);

    const {isOpenSidebar} = useSelector((state: IUserOptions) => state.user.user);

    const {limit, selectContact} = useSelector((state: any) => state.easymerch.serviceTypes);

    const actualLimit = JSON.parse(localStorage.getItem("pageLimit") as string) || limit;

    const handleChangeLimits = (option: { value: number }) => {
        handleChange(option.value, 1);
        resetPages();
    };

    const handleChange = (newLimit: number, newPage: number) => {
        setIsPending(true);
        dispatch(actionGetServiceTypesSelect()).then(() => {
            setIsPending(false);
        });
        localStorage.setItem("pageLimit", JSON.stringify(newLimit));
    };

    const resetPages = () => {
        setCurrentPage(1);
        setStartPage(1);
    };


    useEffect(() => {
        setIsPending(true);
        dispatch(actionGetServiceTypesSelect()).then(() => {
            setIsPending(false);
        });
    }, [dispatch]);

    useEffect(() => {
        const startElement = (currentPage - 1) * actualLimit;
        const endElement = selectContact?.data[startElement + actualLimit]
                           ? startElement + actualLimit
                           : selectContact?.data.length - 1;

        setVisibleRows(selectContact?.data.slice(startElement, endElement));
    }, [selectContact, currentPage, actualLimit]);

    return (
        <>
            <div className="loader__wrapper">{isPending && <Loader/>}</div>

            <div
                className={clsx(
                    JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
                    isOpenSidebar &&
                    "active__table",
                    !isOpenSidebar && "closed__table",
                    "table"
                )}>

                <Toaster position="top-center" toastOptions={{duration: 5000}}/>

                <div className="table__wrapper">
                    <table>
                        <thead>
                        <tr>
                            <th>
                                Список контрактов
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        {visibleRows && visibleRows.map((el: IContract, index: number) => (
                            <tr key={index}>
                                <td>
                                    <Link to={`${el?.id}/info`}
                                          onClick={() => {}}
                                          className="file__link">
                                        {el?.name}
                                    </Link>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <div className="pagination__count">Всего: {selectContact?.count}</div>
                    <div className="pagination__str">
                        <span>Отображать строки</span>
                        <LimitSelect limit={actualLimit} propsChange={handleChangeLimits}/>
                    </div>
                    <Pagination
                        setCurrentPage={setCurrentPage}
                        setStartPage={setStartPage}
                        handleChange={handleChange}
                        currentPage={currentPage}
                        startPage={startPage}
                        count={selectContact?.count}
                        limit={actualLimit}
                        pageName="userReports"
                    />
                </div>
            </div>
        </>
    );
};

export default TableCustomerContractsList;
